<div class="fdm-wizard-overlay" *ngIf="isOpen">
  <div class="fdm-wizard-overlay__backdrop"></div>
  <div class="fdm-wizard-overlay__container">
    <iframe
      class="fdm-wizard-overlay__iframe"
      [src]="iframeSrc"
      frameborder="0"
      allowtransparency="true"
    ></iframe>
  </div>
</div>
